import { A } from "@solidjs/router";
import { createSignal } from "solid-js";
import { ChevronLeftIcon, ListIcon } from "lucide-solid";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";

export function MobilePageNav(props) {
  const [open, setOpen] = createSignal(false);
  const close = () => setOpen(false);

  return (
    <>
      <div class="sticky top-[var(--nav-height,64px)] z-10 -mx-4 px-4 py-3 mb-6 bg-background/90 backdrop-blur-md border-b border-border flex items-center justify-between gap-3 max-h-24 overflow-hidden transition-[max-height,opacity,margin,padding] duration-200 ease-linear motion-reduce:transition-none md:max-h-0 md:mx-0 md:mb-0 md:px-0 md:py-0 md:border-b-0 md:opacity-0 md:pointer-events-none">
        <div class="flex items-center gap-2 min-w-0">
          <A href={props.backHref} class="shrink-0 text-muted-foreground hover:text-foreground transition-colors">
            <ChevronLeftIcon size={18} />
          </A>
          {props.title}
        </div>
        <button
          onClick={() => setOpen(true)}
          aria-label={props.listLabel}
          class="flex-none flex items-center justify-center leading-none py-2 text-muted-foreground hover:text-foreground transition-colors"
        >
          <ListIcon size={18} />
        </button>
      </div>

      <Sheet open={open()} onOpenChange={setOpen}>
        <SheetContent position="bottom" class="rounded-t-2xl px-0 pb-8">
          <SheetHeader class="px-5 pb-3 border-b border-border">
            <SheetTitle class="text-sm font-semibold">{props.sheetTitle}</SheetTitle>
          </SheetHeader>
          <div class="overflow-y-auto max-h-[60vh]">
            {props.children({ close })}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
